const useBrowserLang = () => {
  const browserLang = navigator.language?.split('-')[0] || 'en';

  return browserLang;
};

export default useBrowserLang;
